// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';

import crypto from 'crypto';
import { CommonHelper } from 'components/Common/Helper/Helper';
import { TeamsContext } from "libs/teams-tab";

import * as microsoftTeams from "@microsoft/teams-js";

let myContext = null;

/**
 * This component is used to redirect the user to the Azure authorization endpoint from a popup
 */
class ConsentPopup extends React.Component {

  componentDidMount() {
    // Initialize the Microsoft Teams SDK
    microsoftTeams.initialize();

    // Get the user context in order to extract the tenant ID
    microsoftTeams.getContext((context, error) => {
      let tenant = context['tid']; //Tenant ID of the logged in user
      let client_id = CommonHelper.GetEnv("MICROSOFT_APP_ID"); //Client ID of the Azure AD app registration ( may be from different tenant for multitenant apps)

      let state = crypto.randomBytes(16).toString('base64');
      localStorage.setItem("cws.state", state);
      localStorage.removeItem("cws.error");

      //Form a query for the Azure implicit grant authorization flow
      //https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-implicit-grant-flow      
      let queryParams = {
        tenant: `${tenant}`,
        client_id: `${client_id}`,
        response_type: "token", //token_id in other samples is only needed if using open ID
        scope: "https://graph.microsoft.com/.default",
        redirect_uri: `${CommonHelper.GetFullHostName()}/teamstab/auth-end`,
        nonce: crypto.randomBytes(16).toString('base64'),
        state: state,
        login_hint: context.loginHint,
      }

      let url = `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize?`;
      queryParams = new URLSearchParams(queryParams).toString();
      let authorizeEndpoint = url + queryParams;

      //Redirect to the Azure authorization endpoint. When that flow completes, the user will be directed to auth-end
      //Go to ClosePopup.js
      window.location.assign(authorizeEndpoint);
    });
  }

  render() {
    return (
      <TeamsContext.Consumer>
        {context => {
          myContext = context;
          return (
            <div>
              <h1>Reindirizzamento alla pagina dei permessi...</h1>
            </div>
          )
        }}
      </TeamsContext.Consumer>
    );
  }
}

export default ConsentPopup;